/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_AttachedInputs */

const vi_camera_station_attached = /** @type {(inputs: Camera_Station_AttachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gắn camera vào trạm`)
};

/**

* @param {Camera_Station_AttachedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_attached = /** @type {((inputs?: Camera_Station_AttachedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_AttachedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_attached(inputs)
});